import React from "react";
import Image from "next/image";
import { ReportErrorProps } from "./types";
import classes from "./report-error.module.scss";

export const ReportError = ({ slug, isForbidden }: ReportErrorProps) => {
    const isVin = slug?.length === 17;

    return (
        <div className={classes["report-error"]}>
            <div className={classes["report-error__wrapper"]}>
                <Image
                    src={`/img/history/404.webp`}
                    width={180}
                    height={180}
                    alt="Автомобиль не найден"
                    className={classes["report-error__image"]}
                />
                <div className={classes["report-error__text"]}>
                    <h1 className={classes["report-error__title"]}>
                        {isForbidden ? "Доступ к этому отчёту ограничен" : "Автомобиля нет"}
                    </h1>
                    {isForbidden ? (
                        <p className={classes["report-error__description"]}>
                            У вас недостаточно прав для просмотра этого ресурса.
                        </p>
                    ) : (
                        <p className={classes["report-error__description"]}>
                            Не нашли историю по {isVin ? "VIN" : "госномеру"}. Убедитесь, что он
                            написан без ошибок. Если опечаток нет – попробуйте найти историю по{" "}
                            {isVin ? "госномеру" : "VIN"}.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};